import api from './api';

const nadgodzinyService = {
  getKontekstZlozenia: async () => {
    const response = await api.get('/nadgodziny/kontekst-zlozenia');
    return response.data;
  },

  /** Lekki licznik do menu */
  getLicznik: async () => {
    const response = await api.get('/nadgodziny/licznik');
    return response.data;
  },

  getOsobyDoPrzekazania: async () => {
    const response = await api.get('/nadgodziny/osoby-do-przekazania');
    return response.data;
  },

  getMoje: async () => {
    const response = await api.get('/nadgodziny/moje');
    return response.data;
  },

  getDoDecyzji: async () => {
    const response = await api.get('/nadgodziny/do-decyzji');
    return response.data;
  },

  getPrzeglad: async () => {
    const response = await api.get('/nadgodziny/przeglad');
    return response.data;
  },

  /** Pełny wniosek (z podpisami) — do szczegółów i PDF */
  getWniosek: async (id) => {
    const response = await api.get(`/nadgodziny/${id}`);
    return response.data;
  },

  create: async (dane) => {
    const response = await api.post('/nadgodziny', dane);
    return response.data;
  },

  update: async (id, dane) => {
    const response = await api.put(`/nadgodziny/${id}`, dane);
    return response.data;
  },

  cofnij: async (id) => {
    const response = await api.put(`/nadgodziny/${id}/cofnij`);
    return response.data;
  },

  podejmijDecyzje: async (id, decyzja) => {
    const response = await api.put(`/nadgodziny/${id}/decyzja`, decyzja);
    return response.data;
  },

  zwrocDoPracownika: async (id, komentarz) => {
    const response = await api.put(`/nadgodziny/${id}/zwroc-do-pracownika`, { komentarz });
    return response.data;
  },

  przekaz: async (id, nowyPrzełożony, powod) => {
    const response = await api.put(`/nadgodziny/${id}/przekaz`, { nowyPrzełożony, powod });
    return response.data;
  },

  potwierdzRealizacje: async (id, dane) => {
    const response = await api.put(`/nadgodziny/${id}/realizacja`, dane);
    return response.data;
  },

  akceptujPrzekroczenie: async (id) => {
    const response = await api.put(`/nadgodziny/${id}/realizacja/akceptuj`);
    return response.data;
  },

  korygujRealizacje: async (id, dane) => {
    const response = await api.put(`/nadgodziny/${id}/realizacja/korekta`, dane);
    return response.data;
  },

  rozlicz: async (id, uwagi) => {
    const response = await api.put(`/nadgodziny/${id}/rozlicz`, { uwagi });
    return response.data;
  },

  // ===== Limity Kodeksu pracy, konfiguracja, raporty =====

  getKonfiguracja: async () => {
    const response = await api.get('/nadgodziny/konfiguracja');
    return response.data;
  },

  zapiszKonfiguracje: async (dane) => {
    const response = await api.put('/nadgodziny/konfiguracja', dane);
    return response.data;
  },

  /** Stan limitów pracownika dla planowanego wniosku (formularz składania) */
  getLimity: async (params) => {
    const response = await api.get('/nadgodziny/limity', { params });
    return response.data;
  },

  /** Stan limitów dla istniejącego wniosku (okno decyzji) */
  getLimityWniosku: async (id) => {
    const response = await api.get(`/nadgodziny/${id}/limity`);
    return response.data;
  },

  getPodsumowanie: async (rok) => {
    const response = await api.get('/nadgodziny/podsumowanie', { params: { rok } });
    return response.data;
  },

  /** Pobiera plik eksportu dla płac i zapisuje go w przeglądarce */
  pobierzEksport: async (miesiac, format = 'csv') => {
    const response = await api.get('/nadgodziny/eksport', { params: { miesiac, format }, responseType: 'blob' });
    const url = window.URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `nadgodziny-${miesiac}.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
};

export default nadgodzinyService;
